import { useState } from 'react';
import Link from 'next/link';
import { FaPlus, FaMinus } from 'react-icons/fa';

type FaqItem = {
  question: string;
  answer: string;
};

type FaqSectionProps = {
  faqs: FaqItem[];
};

const FAQSection: React.FC<FaqSectionProps> = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="px-5 py-16 md:py-28" id="faqs">
      <div className="max-w-[768px] mx-auto w-full">
        <h2 className="font-semibold text-[30px] md:text-[36px] text-center mb-10 md:mb-16">FAQs</h2>

        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-[#000000] rounded-[10px]">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-4 md:px-5 py-6 flex justify-between gap-3 cursor-pointer items-center text-left text-[16px] md:text-[18px] font-medium"
              >
                {faq.question}
                {openIndex === index ? (
                  <FaMinus className="w-4 h-4 transition-transform duration-300" />
                ) : (
                  <FaPlus className="w-4 h-4 transition-transform duration-300" />
                )}
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index
                    ? 'max-h-40 md:max-h-52 px-4 md:px-5 pb-4'
                    : 'max-h-0 px-4 md:px-5'
                  }`}
              >
                <p className="text-[16px] md:text-[18px] text-gray-600">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <h3 className="text-[24px] md:text-[30px] font-semibold mb-6">Still have a question?</h3>
          <Link href="/contact-us" passHref>
            <button className="bg-[#ED7523] hover:opacity-90 text-white px-6 py-3 rounded-[10px] font-medium text-[16px] cursor-pointer transition-colors duration-300">
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
